import { Convention } from '../../../concepts/objects';
import { TagSupport } from '../annotations/TagSupport';

export const Commentable = new Convention<Commentable>('Votable');
export interface Commentable extends TagSupport { }
